module.exports = __webpack_public_path__ + "static/loader-919666edc338490fcd6fa8890a859c89.gif";